<div class="content-management-modal" role="document">
  <div class="modal-header">
    <div class="btn-modal-close cursor-pointer" [attr.aria-label]="'Close ' + (data?.heading || 'dialog')">
      <img src="assets/images/neveda-images/close.svg" id="close_img" (click)="close()"
        (keypress)="close()" alt="close_icon" tabindex="0">
    </div>
  </div>

  <div class="modal-body">
    <div class="scrollable-content" role="region"
      tabindex="1">
      <div class="ql-snow">
        <div class="template-content ql-editor" [innerHTML]="data?.content | safeHtml"></div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="modal-flex-button flex-fill center">
      <button type="button" class="btn btn-outline close-btn" (click)="close()" [attr.aria-label]="'Close ' + (data?.heading || 'dialog')">
        Close
      </button>
    </div>
  </div>
</div>
